<template>
    <div>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="1" v-model="row.value"> {{ $e('Monday') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="2" v-model="row.value"> {{ $e('Tuesday') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="3" v-model="row.value"> {{ $e('Wednesday') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="4" v-model="row.value"> {{ $e('Thursday') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="5" v-model="row.value"> {{ $e('Friday') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="6" v-model="row.value"> {{ $e('Saturday') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="7" v-model="row.value"> {{ $e('Sunday') }}</label>
    </div>
</template>

<script>
export default {
    props: {
        row: { type: Object, required: true }
    },
    mounted() {
        if (! this.row.value) {
            this.row.value = []
        }
    }
}
</script>

<style scoped>
.opui-form-check-label {
    margin-right: 15px;
}

.opui-form-check-input {
    margin-left: 0;
    margin-top: -3px;
    position: relative;
}
</style>
